export enum RentSchedule {
	Weekly = 0,
	Monthly = 10
}